import React from "react";
import {Tooltip} from "antd";
import {FileSearchOutlined} from "@ant-design/icons";
import moment from "moment";
import {formatMoney2} from "utils/moneyHelper";
import {InnerTable, DetailIconButton} from "../styles/SubCompanyInvoice.styles";
import {NETSIS_INVOICE_STATUS_LABELS} from "./NetsisInvoiceStatusFilter";

const formatDate = date => (date ? moment(date).format("DD.MM.YYYY") : "-");
const formatAmount = amount => formatMoney2({amount, currency: "TL"});

const openCreditLogs = ({invoiceId, periodStartDate, periodEndDate}) => {
    const params = new URLSearchParams({tab: "subCompanyTotalDetail", invoiceId});
    if (periodStartDate && periodEndDate) {
        params.set("startDate", moment(periodStartDate).format("YYYY-MM-DD"));
        params.set("endDate", moment(periodEndDate).format("YYYY-MM-DD"));
    }
    window.open(`/credit-logs?${params.toString()}`, "_blank");
};

const columns = [
    {title: "Fatura Tarihi", dataIndex: "invoiceDate", render: formatDate},
    {title: "Fatura Tutarı (KDV Hariç)", dataIndex: "amount", render: formatAmount},
    {title: "Fatura Tutarı (KDV Dahil)", dataIndex: "amountWithVAT", render: formatAmount},
    {
        title: "Durum",
        dataIndex: "status",
        render: status => NETSIS_INVOICE_STATUS_LABELS[status] || "-"
    },
    {
        title: "Dönem",
        render: (_, row) => `${formatDate(row.periodStartDate)} - ${formatDate(row.periodEndDate)}`
    },
    {
        title: "",
        width: 48,
        align: "center",
        render: (_, row) => (
            <Tooltip title="Kredi Hareketleri">
                <DetailIconButton onClick={() => openCreditLogs(row)}>
                    <FileSearchOutlined />
                </DetailIconButton>
            </Tooltip>
        )
    }
];

export const ServiceInvoiceTable = ({invoices}) => (
    <InnerTable
        $variant="service"
        size="small"
        columns={columns}
        dataSource={invoices}
        rowKey="invoiceId"
        pagination={false}
        locale={{emptyText: "Vigo hizmet faturası bulunamadı."}}
    />
);
